/**
 * BAB Smart Search – Fuse.js Live-Suche über bab-ai-assistant (nur Suchseite).
 */
(function () {
  'use strict';

  var API_BASE =
    'https://ki.bab-berufsbekleidung.shop/search/instant';
  var MIN_CHARS = 3;
  var DEBOUNCE_MS = 300;
  var CACHE_TTL_MS = 5 * 60 * 1000;

  var searchCache = new Map();

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function hidePredictiveDropdowns() {
    document.querySelectorAll('[data-bab-search-dropdown]').forEach(function (el) {
      el.hidden = true;
    });
  }

  function smartSearch(query) {
    var q = String(query || '').trim();
    if (q.length < MIN_CHARS) {
      return Promise.resolve({
        query: q,
        corrected: null,
        results: [],
        total: 0
      });
    }
    if (searchCache.has(q)) {
      return Promise.resolve(searchCache.get(q));
    }
    var url =
      API_BASE + '?q=' + encodeURIComponent(q);
    return fetch(url, { method: 'GET', credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('instant search failed');
        return r.json();
      })
      .then(function (data) {
        searchCache.set(q, data);
        setTimeout(function () {
          searchCache.delete(q);
        }, CACHE_TTL_MS);
        return data;
      })
      .catch(function () {
        return {
          query: q,
          corrected: null,
          results: [],
          total: 0
        };
      });
  }

  function findSearchInputs() {
    var seen = new Set();
    var out = [];
    function add(el) {
      if (!el || seen.has(el)) return;
      seen.add(el);
      out.push(el);
    }
    document.querySelectorAll('input[data-bab-search-input]').forEach(add);
    var t = document.querySelector('#Search-In-Template');
    if (t && t.matches('input')) add(t);
    document
      .querySelectorAll(
        'form[action*="/search"] input[name="q"]'
      )
      .forEach(add);
    return out;
  }

  function ensurePanel(input) {
    var wrap =
      input.closest('.bab-search__field-wrap') ||
      input.closest('form') ||
      input.parentElement;
    if (!wrap) return null;
    var id = 'bab-smart-search-panel-' + (input.id || 'anon');
    var existing = document.getElementById(id);
    if (existing) return existing;

    var panel = document.createElement('div');
    panel.id = id;
    panel.className = 'bab-smart-search-panel';
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Suchvorschläge');
    panel.hidden = true;
    panel.innerHTML =
      '<div class="bab-smart-search-panel__inner"></div>';
    wrap.style.position = wrap.style.position || 'relative';
    wrap.appendChild(panel);
    return panel;
  }

  function injectStylesOnce() {
    if (document.getElementById('bab-smart-search-styles')) return;
    var style = document.createElement('style');
    style.id = 'bab-smart-search-styles';
    style.textContent =
      '.bab-smart-search-panel{position:absolute;left:0;right:0;top:100%;margin-top:8px;z-index:9998;}' +
      '.bab-smart-search-panel__inner{background:rgba(28,28,28,0.98);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border:1px solid rgba(255,255,255,.1);border-radius:16px;box-shadow:0 24px 60px rgba(0,0,0,.6);max-height:min(70vh,520px);overflow-y:auto;padding:10px 0;}' +
      '.bab-smart-search-meta{font-size:12px;color:rgba(255,255,255,.55);padding:6px 14px 10px;}' +
      '.bab-smart-search-suggest{font-size:12px;color:rgba(255,255,255,.75);padding:0 14px 8px;border-bottom:1px solid rgba(255,255,255,.08);margin-bottom:6px;}' +
      '.bab-smart-search-suggest a{color:#9ecfff;cursor:pointer;text-decoration:underline;}' +
      '.bab-smart-search-row{display:flex;align-items:center;gap:12px;padding:10px 14px;cursor:pointer;text-decoration:none;color:inherit;}' +
      '.bab-smart-search-row:hover,.bab-smart-search-row:focus{background:rgba(255,255,255,.06);outline:none;}' +
      '.bab-smart-search-img{width:48px;height:48px;object-fit:cover;border-radius:8px;flex-shrink:0;background:rgba(255,255,255,.06);}' +
      '.bab-smart-search-text{min-width:0;flex:1;}' +
      '.bab-smart-search-title{font-size:13px;font-weight:700;color:#fff;line-height:1.25;}' +
      '.bab-smart-search-price{font-size:12px;color:#9E3548;font-weight:600;margin-top:2px;}' +
      '.bab-smart-search-vendor{font-size:11px;color:rgba(255,255,255,.45);margin-top:2px;}';
    document.head.appendChild(style);
  }

  function renderResults(panel, input, data) {
    var inner = panel.querySelector('.bab-smart-search-panel__inner');
    if (!inner) return;

    var q = data.query || '';
    var total = typeof data.total === 'number' ? data.total : 0;
    var results = Array.isArray(data.results) ? data.results : [];
    var corrected = data.corrected || null;

    var html = '';

    if (corrected) {
      html +=
        '<div class="bab-smart-search-suggest">Meinten Sie: <a data-bab-corrected="' +
        escapeHtml(corrected) +
        '" href="#">' +
        escapeHtml(corrected) +
        '</a>?</div>';
    }

    if (q.length >= MIN_CHARS) {
      html +=
        '<div class="bab-smart-search-meta">' +
        escapeHtml(String(total)) +
        ' Ergebnis' +
        (total === 1 ? '' : 'e') +
        " für „" +
        escapeHtml(q) +
        '“</div>';
    }

    if (results.length === 0) {
      html +=
        '<div class="bab-smart-search-meta" style="padding-top:4px;">Keine Treffer</div>';
    } else {
      results.slice(0, 8).forEach(function (row) {
        var url = row.url || '#';
        var img = row.image
          ? '<img class="bab-smart-search-img" src="' +
            escapeHtml(row.image) +
            '" alt="" loading="lazy" width="48" height="48">'
          : '<span class="bab-smart-search-img" aria-hidden="true"></span>';
        html +=
          '<a class="bab-smart-search-row" role="option" href="' +
          escapeHtml(url) +
          '">' +
          img +
          '<span class="bab-smart-search-text"><span class="bab-smart-search-title">' +
          escapeHtml(row.displayTitle || row.title || '') +
          '</span><div class="bab-smart-search-price">' +
          escapeHtml(String(row.price != null ? row.price : '')) +
          '</div><div class="bab-smart-search-vendor">' +
          escapeHtml(String(row.vendor || '')) +
          '</div></span></a>';
      });
    }

    inner.innerHTML = html;

    inner.querySelectorAll('[data-bab-corrected]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var text = a.getAttribute('data-bab-corrected') || '';
        input.value = text;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    });

    panel.hidden = q.length < MIN_CHARS;
    if (!panel.hidden) hidePredictiveDropdowns();
  }

  function hidePanel(panel) {
    if (panel) panel.hidden = true;
  }

  function bindInput(input) {
    if (!input) return;
    // Header-Input überspringen —
    // hat eigenes vollständiges Dropdown
    // in bab-header.liquid
    if (
      input.id === 'bab-nav-search-input' ||
      input.closest('#bab-nav-search-form') !== null
    ) return;
    if (input.dataset.babSmartSearchBound === '1') return;
    input.dataset.babSmartSearchBound = '1';

    var panel = ensurePanel(input);
    var form = input.closest('form');
    var debounceTimer = null;
    var lastPayload = null;

    function schedule() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var v = input.value.trim();
        if (v.length < MIN_CHARS) {
          lastPayload = null;
          hidePanel(panel);
          return;
        }
        smartSearch(v).then(function (data) {
          lastPayload = data;
          if (panel) renderResults(panel, input, data);
        });
      }, DEBOUNCE_MS);
    }

    input.addEventListener('input', schedule);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS) schedule();
    });

    if (form && form.dataset.babSmartSubmitBound !== '1') {
      form.dataset.babSmartSubmitBound = '1';
      form.addEventListener('submit', function () {
        var v = input.value.trim();
        if (
          lastPayload &&
          lastPayload.corrected &&
          lastPayload.query === v
        ) {
          input.value = String(lastPayload.corrected).trim();
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (!panel || panel.hidden) return;
      var t = e.target;
      if (panel.contains(t) || input.contains(t) || input === t) return;
      hidePanel(panel);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hidePanel(panel);
    });
  }

  function init() {
    injectStylesOnce();
    findSearchInputs().forEach(bindInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
